<div class="invoice-imports" *ngIf="!selectedImportId && !selectedGroupKey">
  <ul class="nav nav-pills mb-3">
    <li class="nav-item">
      <a class="nav-link" [class.active]="section === 'invoices'" href="javascript:void(0)" (click)="section = 'invoices'">
        {{ 'INVOICE_IMPORTS.TAB_INVOICES' | translate }}
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="section === 'settings'" href="javascript:void(0)" (click)="section = 'settings'">
        {{ 'INVOICE_IMPORTS.TAB_SETTINGS' | translate }}
      </a>
    </li>
  </ul>

  <app-invoice-import-settings *ngIf="section === 'settings'" [storeId]="storeId"></app-invoice-import-settings>

  <ng-container *ngIf="section === 'invoices'">
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
      <div>
        <h4 class="mb-1">{{ 'INVOICE_IMPORTS.TITLE' | translate }}</h4>
        <p class="text-muted small mb-0">{{ 'INVOICE_IMPORTS.SUBTITLE' | translate }}</p>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="refreshAll()">
          <nb-icon icon="refresh-outline"></nb-icon>
          {{ 'INVOICE_IMPORTS.ACTIONS.REFRESH' | translate }}
        </button>
        <label class="btn btn-primary btn-sm mb-0">
          <nb-icon icon="upload-outline" class="me-1"></nb-icon>
          {{ 'INVOICE_IMPORTS.ACTIONS.UPLOAD_PDF' | translate }}
          <input type="file" accept=".pdf,.fak,.zip,application/pdf,application/zip" multiple hidden (change)="onUploadInput($event)" />
        </label>
        <span class="small text-muted align-self-center">{{ 'INVOICE_IMPORTS.UPLOAD.ACCEPT_HINT' | translate }}</span>
      </div>
    </div>

    <div class="alert alert-warning" *ngIf="overview && !overview.inventoryManagementEnabled">
      {{ 'INVOICE_IMPORTS.OVERVIEW.INVENTORY_DISABLED' | translate }}
    </div>

    <div class="alert alert-danger" *ngIf="overviewError">{{ overviewError }}</div>

    <div class="row g-3 mb-3" *ngIf="overview">
      <div class="col-6 col-md-4 col-lg-2">
        <nb-card class="metric-card mb-0">
          <nb-card-body class="py-2">
            <div class="metric-value">{{ overview.counts.readyForReview }}</div>
            <div class="metric-label">{{ 'INVOICE_IMPORTS.OVERVIEW.TILE_READY' | translate }}</div>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="col-6 col-md-4 col-lg-2">
        <nb-card class="metric-card mb-0">
          <nb-card-body class="py-2">
            <div class="metric-value">{{ overview.counts.linesNeedingAttention }}</div>
            <div class="metric-label">{{ 'INVOICE_IMPORTS.OVERVIEW.TILE_LINES' | translate }}</div>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="col-6 col-md-4 col-lg-2">
        <nb-card class="metric-card mb-0">
          <nb-card-body class="py-2">
            <div class="metric-value">{{ overview.counts.parseFailed }}</div>
            <div class="metric-label">{{ 'INVOICE_IMPORTS.OVERVIEW.TILE_PARSE_FAILED' | translate }}</div>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="col-6 col-md-4 col-lg-2">
        <nb-card class="metric-card mb-0">
          <nb-card-body class="py-2">
            <div class="metric-value">{{ overview.counts.duplicates }}</div>
            <div class="metric-label">{{ 'INVOICE_IMPORTS.OVERVIEW.TILE_DUPLICATES' | translate }}</div>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="col-12 col-lg-4">
        <nb-card class="mb-0 inbound-card">
          <nb-card-body class="py-2">
            <div class="small text-muted">{{ 'INVOICE_IMPORTS.OVERVIEW.INBOUND_LABEL' | translate }}</div>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <code class="inbound-address">{{ overview.inboundAddress }}</code>
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="copyInboundAddress()">
                {{ 'INVOICE_IMPORTS.OVERVIEW.COPY' | translate }}
              </button>
            </div>
            <ol class="small text-muted mb-0 mt-2 ps-3 help-steps">
              <li>{{ 'INVOICE_IMPORTS.OVERVIEW.HELP_1' | translate }}</li>
              <li>{{ 'INVOICE_IMPORTS.OVERVIEW.HELP_2' | translate }}</li>
              <li>{{ 'INVOICE_IMPORTS.OVERVIEW.HELP_3' | translate }}</li>
            </ol>
          </nb-card-body>
        </nb-card>
      </div>
    </div>

    <div class="mb-3" *ngIf="unassignedTotal > 0">
      <button type="button" class="btn btn-sm btn-outline-warning" (click)="goUnassigned()">
        {{ 'INVOICE_IMPORTS.UNASSIGNED.BADGE' | translate:{ count: unassignedTotal } }}
      </button>
    </div>

    <ul class="nav nav-tabs mb-3 list-view-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="listView === 'invoices'"
          href="javascript:void(0)"
          (click)="setListView('invoices')">
          {{ 'INVOICE_IMPORTS.LIST_VIEW.INVOICES' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [class.active]="listView === 'deliveries'"
          href="javascript:void(0)"
          (click)="setListView('deliveries')">
          {{ 'INVOICE_IMPORTS.LIST_VIEW.DELIVERIES' | translate }}
        </a>
      </li>
    </ul>

    <nb-card *ngIf="listView === 'invoices'">
      <nb-card-body>
        <div class="filters row g-2 mb-3">
          <div class="col-md-4">
            <input
              class="form-control form-control-sm"
              [placeholder]="'INVOICE_IMPORTS.LIST.SEARCH_PLACEHOLDER' | translate"
              [(ngModel)]="searchQ"
              (keyup.enter)="applyFilters()" />
          </div>
          <div class="col-md-2">
            <input type="date" class="form-control form-control-sm" [(ngModel)]="dateFrom" />
          </div>
          <div class="col-md-2">
            <input type="date" class="form-control form-control-sm" [(ngModel)]="dateTo" />
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-sm btn-primary w-100" (click)="applyFilters()">
              {{ 'INVOICE_IMPORTS.LIST.APPLY_FILTERS' | translate }}
            </button>
          </div>
        </div>

        <div class="status-chips mb-3">
          <span class="small text-muted me-2">{{ 'INVOICE_IMPORTS.LIST.STATUS_FILTER' | translate }}</span>
          <label class="chip" *ngFor="let st of allStatuses">
            <input type="checkbox" [checked]="isStatusSelected(st)" (change)="toggleStatus(st, $any($event.target).checked)" />
            {{ statusLabelKey(st) | translate }}
          </label>
        </div>

        <div class="alert alert-danger" *ngIf="listError">{{ listError }}</div>

        <div class="empty-state text-center py-5 text-muted" *ngIf="!listError && items.length === 0">
          <p class="mb-2">{{ 'INVOICE_IMPORTS.LIST.EMPTY' | translate }}</p>
          <code *ngIf="overview">{{ overview.inboundAddress }}</code>
        </div>

        <div class="table-responsive d-none d-md-block" *ngIf="items.length">
          <table class="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>{{ 'INVOICE_IMPORTS.LIST.COL_WHOLESALER' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.LIST.COL_INVOICE' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.LIST.COL_GROUP' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.LIST.COL_DELIVERY' | translate }}</th>
                <th class="text-end">{{ 'INVOICE_IMPORTS.LIST.COL_TOTAL' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.LIST.COL_STATUS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="list-row" *ngFor="let row of items" (click)="openDetail(row)">
                <td>{{ row.supplierDisplayName || row.supplierKey || '—' }}</td>
                <td>
                  {{ row.invoiceNumber || '—' }}
                  <span class="text-muted" *ngIf="row.invoiceSite">({{ row.invoiceSite }})</span>
                </td>
                <td>{{ row.productGroupLabel || '—' }}</td>
                <td>{{ row.deliveryDate | date:'dd/MM/yyyy' }}</td>
                <td class="text-end">{{ row.totals?.totalInclVat | number:'1.2-2':'da-DK' }} kr.</td>
                <td>
                  <span class="badge" [ngClass]="row.status | invoiceImportStatusClass">{{ statusLabelKey(row.status) | translate }}</span>
                  <span class="badge bg-warning text-dark ms-1" *ngIf="row.lineCounts?.needsAttention">
                    {{ 'INVOICE_IMPORTS.LIST.NEEDS_ATTENTION' | translate:{ count: row.lineCounts?.needsAttention } }}
                  </span>
                  <nb-icon
                    *ngIf="row.reconciliation?.status && row.reconciliation?.status !== 'ok'"
                    icon="alert-triangle-outline"
                    status="warning"
                    class="ms-1"></nb-icon>
                  <a
                    *ngIf="row.duplicateOfImportId"
                    class="small ms-1"
                    href="javascript:void(0)"
                    (click)="openDuplicateImport(row.duplicateOfImportId, $event)">
                    {{ 'INVOICE_IMPORTS.LIST.DUPLICATE_LINK' | translate }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-md-none line-cards" *ngIf="items.length">
          <nb-card class="mb-2 list-card" *ngFor="let row of items" (click)="openDetail(row)">
            <nb-card-body class="py-2">
              <div class="fw-semibold">{{ row.supplierDisplayName || row.supplierKey }}</div>
              <div class="small">{{ row.invoiceNumber }} · {{ row.deliveryDate | date:'dd/MM/yyyy' }}</div>
              <div class="d-flex justify-content-between align-items-center mt-1">
                <span class="badge" [ngClass]="row.status | invoiceImportStatusClass">{{ statusLabelKey(row.status) | translate }}</span>
                <span>{{ row.totals?.totalInclVat | number:'1.2-2':'da-DK' }} kr.</span>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="total > limit">
          <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page <= 1" (click)="onPageChange(page - 1)">
            {{ 'INVOICE_IMPORTS.LIST.PREV' | translate }}
          </button>
          <span class="small text-muted">{{ page }} / {{ Math.ceil(total / limit) }}</span>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="page * limit >= total"
            (click)="onPageChange(page + 1)">
            {{ 'INVOICE_IMPORTS.LIST.NEXT' | translate }}
          </button>
        </div>
      </nb-card-body>
    </nb-card>

    <nb-card *ngIf="listView === 'deliveries'">
      <nb-card-body>
        <div class="filters row g-2 mb-3">
          <div class="col-md-2">
            <input type="date" class="form-control form-control-sm" [(ngModel)]="dateFrom" />
          </div>
          <div class="col-md-2">
            <input type="date" class="form-control form-control-sm" [(ngModel)]="dateTo" />
          </div>
          <div class="col-md-3">
            <div class="btn-group btn-group-sm w-100">
              <button
                type="button"
                class="btn"
                [class.btn-primary]="deliveryStatusFilter === 'open'"
                [class.btn-outline-primary]="deliveryStatusFilter !== 'open'"
                (click)="setDeliveryStatusFilter('open')">
                {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.FILTER_OPEN' | translate }}
              </button>
              <button
                type="button"
                class="btn"
                [class.btn-primary]="deliveryStatusFilter === 'all'"
                [class.btn-outline-primary]="deliveryStatusFilter !== 'all'"
                (click)="setDeliveryStatusFilter('all')">
                {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.FILTER_ALL' | translate }}
              </button>
            </div>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-sm btn-primary w-100" (click)="applyDeliveryFilters()">
              {{ 'INVOICE_IMPORTS.LIST.APPLY_FILTERS' | translate }}
            </button>
          </div>
        </div>

        <div class="alert alert-danger" *ngIf="deliveryListError">{{ deliveryListError }}</div>

        <div class="empty-state text-center py-5 text-muted" *ngIf="!deliveryListError && deliveryGroups.length === 0">
          <p class="mb-0">{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.EMPTY' | translate }}</p>
        </div>

        <div class="table-responsive d-none d-md-block" *ngIf="deliveryGroups.length">
          <table class="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th>{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.COL_DELIVERY' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.KUNDENUMMER' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.COL_INVOICES' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.COL_INVOICE_NOS' | translate }}</th>
                <th class="text-end">{{ 'INVOICE_IMPORTS.LIST.COL_TOTAL' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.COL_ATTENTION' | translate }}</th>
                <th>{{ 'INVOICE_IMPORTS.LIST.COL_STATUS' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="list-row" *ngFor="let row of deliveryGroups" (click)="openDeliveryGroup(row)">
                <td>{{ row.deliveryDate | date:'dd/MM/yyyy' }}</td>
                <td>{{ row.kundenummer || '—' }}</td>
                <td>{{ row.importCount || row.importIds?.length || '—' }}</td>
                <td class="small">{{ deliveryInvoiceNumbersLabel(row) }}</td>
                <td class="text-end">{{ row.totals?.totalInclVat | number:'1.2-2':'da-DK' }} kr.</td>
                <td>
                  <span class="badge bg-warning text-dark" *ngIf="row.lineCounts?.needsAttention">
                    {{ row.lineCounts?.needsAttention }}
                  </span>
                  <span *ngIf="!row.lineCounts?.needsAttention">—</span>
                </td>
                <td>
                  <ng-container *ngIf="row.statuses as statuses">
                    <span
                      class="badge me-1"
                      *ngFor="let st of (statuses | keyvalue)"
                      [ngClass]="st.key | invoiceImportStatusClass">
                      {{ statusLabelKey(st.key) | translate }} ({{ st.value }})
                    </span>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-md-none line-cards" *ngIf="deliveryGroups.length">
          <nb-card class="mb-2 list-card" *ngFor="let row of deliveryGroups" (click)="openDeliveryGroup(row)">
            <nb-card-body class="py-2">
              <div class="fw-semibold">{{ row.deliveryDate | date:'dd/MM/yyyy' }} · {{ row.kundenummer }}</div>
              <div class="small">{{ deliveryInvoiceNumbersLabel(row) }}</div>
              <div class="d-flex justify-content-between align-items-center mt-1">
                <span class="small">{{ row.importCount }} {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.INVOICES_SHORT' | translate }}</span>
                <span>{{ row.totals?.totalInclVat | number:'1.2-2':'da-DK' }} kr.</span>
              </div>
            </nb-card-body>
          </nb-card>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="deliveryTotal > deliveryLimit">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="deliveryPage <= 1"
            (click)="onDeliveryPageChange(deliveryPage - 1)">
            {{ 'INVOICE_IMPORTS.LIST.PREV' | translate }}
          </button>
          <span class="small text-muted">{{ deliveryPage }} / {{ Math.ceil(deliveryTotal / deliveryLimit) }}</span>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="deliveryPage * deliveryLimit >= deliveryTotal"
            (click)="onDeliveryPageChange(deliveryPage + 1)">
            {{ 'INVOICE_IMPORTS.LIST.NEXT' | translate }}
          </button>
        </div>
      </nb-card-body>
    </nb-card>
  </ng-container>
</div>

<app-delivery-group-detail
  *ngIf="selectedGroupKey"
  [storeId]="storeId"
  [groupKey]="selectedGroupKey"
  (closed)="onDeliveryGroupClosed($event)"
  (openImport)="openImportFromGroup($event)"></app-delivery-group-detail>

<app-invoice-import-detail
  *ngIf="selectedImportId"
  [storeId]="storeId"
  [importId]="selectedImportId"
  (closed)="onDetailClosed($event)"></app-invoice-import-detail>
